// extracted by mini-css-extract-plugin
export default {"section":"MainSection_section__NhuHA"};